export function LocationCustomization({
    logo,
    loginBackground,
    accentColor,
    headerColor,
    managedByPMSCustomization = false,
    // The location's OWN colours (undefined when it has none). accentColor
    // and headerColor above arrive already merged with the template, so only
    // these tell an own colour from an inherited one.
    ownAccentColor,
    ownHeaderColor,
    // Same for the logo: `logo` above arrives merged with the template.
    ownLogo,
    // Name of the organization an inherited value comes from; undefined when
    // it comes from the legacy personal template.
    inheritedFromOrganization,
} = {}) {
    return {
        logo,
        loginBackground,
        accentColor,
        headerColor,
        managedByPMSCustomization,
        ownAccentColor,
        ownHeaderColor,
        ownLogo,
        inheritedFromOrganization,
    };
}